import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { openRegisteredClubAdmin } from "../../../utils/authRedirect";
import { isOwner } from "../../../utils/roles";
import PlatformAuthShell from "../Auth/PlatformAuthShell";
import a from "../Auth/auth.module.css";

export default function ClinicCreatedSuccess() {
  const navigate = useNavigate();
  const { tenant, isAuth, role } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuth || !isOwner(role) || !tenant?.subdomain) {
      navigate("/register-clinic", { replace: true });
      return;
    }
    openRegisteredClubAdmin(tenant.subdomain);
  }, [isAuth, role, tenant, navigate]);

  return (
    <PlatformAuthShell
      backTo="/"
      backLabel="На главную"
      title="Клуб создан"
      subtitle="Открываем панель управления…"
    >
      <div className={a.successIcon} aria-hidden>
        ✓
      </div>
    </PlatformAuthShell>
  );
}
